export default "__VITE_ASSET__e8a5961b__"